/** @jsxImportSource @emotion/react */
import { CampoInformacion } from "../../shared";
import { Divider } from "primereact/divider";

export default function ActividadEnPropuesta({
  actividad,
  index,
  monedas,
  propuesta,
}) {
  let moneda;
  for (const unaMoneda of monedas) {
    if (unaMoneda.id === actividad.monedaid) {
      moneda = { etiqueta: unaMoneda.nombre, simbolo: unaMoneda.simbolo };
    }
  }

  return (
    <div>
      {index !== 0 && <Divider />}
      <div className="grid">
        <CampoInformacion nombreCampo="Proceso">
          {actividad.procesonombre} - {actividad.procesonombrefantasia}
        </CampoInformacion>
        <CampoInformacion nombreCampo="Actividad">
          {actividad.actividadnombre}
        </CampoInformacion>

        {actividad.reglamentacion && (
          <CampoInformacion nombreCampo="Reglamentación">
            {actividad.reglamentacion}
          </CampoInformacion>
        )}

        {actividad.norma && (
          <CampoInformacion nombreCampo="Norma">
            {actividad.norma}
          </CampoInformacion>
        )}
        {actividad.esquema?.descripcion && (
          <CampoInformacion nombreCampo="Esquema de certificación">
            {actividad.esquema.descripcion}
          </CampoInformacion>
        )}
        {!actividad.esquema?.descripcion && actividad.esquema?.nombre && (
          <CampoInformacion nombreCampo="Esquema de certificación">
            {actividad.esquema.nombre}
          </CampoInformacion>
        )}

        {actividad.notasPropuesta && (
          <CampoInformacion nombreCampo="Notas">
            {actividad.notasPropuesta}
          </CampoInformacion>
        )}

        <CampoInformacion nombreCampo="Costo de la actividad">
          <strong>{`${moneda?.simbolo} ${actividad.precio} (${moneda?.etiqueta})`}</strong>
          {propuesta.masiva && <span> más IVA</span>}
        </CampoInformacion>
      </div>
    </div>
  );
}
